import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { PerfilRiesgoEstadoAutomatico } from '../_models/perfil-riesgo-estado-automatico';

@Injectable({
  providedIn: 'root'
})
export class PerfilRiesgoEstadoAutomaticoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/perfilesRiesgosEstadosAutomaticos/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PerfilRiesgoEstadoAutomatico[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as PerfilRiesgoEstadoAutomatico[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + id ).pipe( map( res => res as PerfilRiesgoEstadoAutomatico ) );
  }

  obtenerPorPerfilRiesgo( id: string ) {
    return this.httClient.get( this.rutServicio + 'perfilRiesgo/' + id ).pipe( map( res => res as PerfilRiesgoEstadoAutomatico ) );
  }

  crear( regCrear: PerfilRiesgoEstadoAutomatico ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PerfilRiesgoEstadoAutomatico ) );
  }

  actualizar( regActualizar: PerfilRiesgoEstadoAutomatico ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
